// extracted by mini-css-extract-plugin
export default {"authCodeInput":"authcode_authCodeInput__RPQvR"};